import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getToken, getProfile } from "./api";
import Gate from "./Gate";
import Home from "./Home";
import Checklist from "./Checklist";
import Sundries from "./Sundries";
import Bikes from "./Bikes";
import Videos from "./Videos";
import Manager from "./Manager";
import Scheduler from "./Scheduler";
import SuperAdmin from "./SuperAdmin";

function Guard({ children }) {
  const location = useLocation();
  if (!getToken() || !getProfile()?.name) {
    return <Navigate to="/staff/entry" replace state={{ from: location }} />;
  }
  return children;
}

export default function StaffApp() {
  return (
    <div data-testid="staff-app">
      <Routes>
        <Route path="entry" element={<Gate />} />
        <Route path="" element={<Guard><Home /></Guard>} />
        <Route path="checklist" element={<Guard><Checklist /></Guard>} />
        <Route path="sundries" element={<Guard><Sundries /></Guard>} />
        <Route path="bikes" element={<Guard><Bikes /></Guard>} />
        <Route path="videos" element={<Guard><Videos /></Guard>} />
        <Route path="manager" element={<Guard><Manager /></Guard>} />
        <Route path="scheduler" element={<Guard><Scheduler /></Guard>} />
        <Route path="superadmin" element={<SuperAdmin />} />
        <Route path="*" element={<Navigate to="/staff" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </div>
  );
}
